import * as serviceContext from './serviceContext';
import { BASE_URL_M_ADMIN } from '../config';


let options = {};
let headers = new Headers();
const token = sessionStorage.getItem('token');

headers.append('content-type', 'application/json')
headers.append('Authorization', `${token}`);

options.headers = headers;
options.redirect = 'follow';


export async function getAllFeedModules(){
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/feedmodule`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function createFeedModule(body){
    try {
        const response = await serviceContext.post(`${BASE_URL_M_ADMIN}madmin/feedmodule`, JSON.stringify(body), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}